module.exports = __webpack_public_path__ + "static/media/phase_sm.49f89803.svg";